module.exports = __webpack_public_path__ + "static/media/diamind_logo.6ecd38a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diamind_logo.png
// module id = 195
// module chunks = 0